import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TRefundsApi } from './types';

export const refunds: TRefundsApi = {
	getRefunds: (payload) =>
		http.post(endpoint.refunds.LOAD_REFUNDS, payload).then((response) => response.data),
	getRefundBreakdown: (payload) =>
		http.post(endpoint.refunds.LOAD_REFUND_BREAKDOWN, payload).then((response) => response.data),
};
